import { useMsal } from "@azure/msal-react";
import LoadingPage from "./LoadingPage";

export default function AuthErrorPage() {
  useMsal()?.instance?.loginRedirect();
  return <LoadingPage />;
}